module.exports = __webpack_public_path__ + "static/media/PIJL_02.daec942f.png";